
import Vue from 'vue'
import RModal from './index.vue'

const TIMEOUT: number = 33

type Interval = ReturnType<typeof setInterval>
type RenderroClientModalState = {
  interval: Interval | undefined
  remaining: Number
}

export default Vue.extend({
  name: 'ConnectingModal',
  components: {
    RModal,
  },
  props: {
    pending: {
      type: Boolean,
    },
  },
  data(): RenderroClientModalState {
    return {
      remaining: TIMEOUT,
      interval: undefined,
    }
  },
  methods: {
    countdown(): void {
      this.remaining = (this.remaining as number) - 1
      if (this.remaining <= 0) {
        this.$modal.hide('connecting')
        this.reset()
      }
    },
    start(): void {
      this.interval = setInterval(this.countdown, 1000)
    },
    reset(): void {
      clearInterval(this.interval as Interval)
      this.remaining = TIMEOUT
    },
    beforeOpen(event: any): void {
      this.start()
    },
    beforeClose(): void {
      this.reset()
    },
  },
  computed: {
    seconds(): string {
      return `${this.remaining} sec`
    },
  },
})
